// ── 직원 일괄등록 모달 (2026-08-25 UserModals.jsx 300줄 규칙으로 분리, 동작 불변) ──
// 구글시트 붙여넣기 방식 일괄등록. 상태·검증은 useBulkRegister.js 훅이 담당.
import React from 'react';
import Modal from '../../../components/Modal';
import { btn, primaryBtn } from './styles';
import { BULK_COLUMNS, isBulkRowEmpty } from './utils';
import {
  guideBoxStyle, sheetWrapStyle, sheetTableStyle, sheetIndexHeaderStyle,
  sheetHeaderStyle, sheetIndexCellStyle, sheetCellStyle, sheetInputStyle, errorInputStyle,
} from './stylesSheet';

// headerExtra(2026-10-26): 창 맨 위에 끼우는 것 — 운영자 초기설정의 [직원 | 마케터] 고르기. 안 주면 종전 그대로.
export function BulkModal({ bulkHook, departments, headerExtra = null }) {
  const {
    bulkOpen, closeBulkModal, bulkSubmitting,
    bulkRows, bulkErrors, bulkColumns, bulkNonEmptyCount, bulkInvalidRowCount,
    addBulkRows, trimEmptyBulkRows, handleBulkCellChange, handleBulkCellPaste, submitBulk,
  } = bulkHook;
  const columns = bulkColumns || BULK_COLUMNS;

  return (
    <Modal
      open={bulkOpen}
      title="직원 일괄등록"
      icon="📋"
      onClose={closeBulkModal}
      width="min(1200px, 96vw)"
      footer={(
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ color: bulkInvalidRowCount > 0 ? '#dc2626' : 'var(--text-muted)', fontWeight: 600 }}>
            입력 {bulkNonEmptyCount} / 오류 {bulkInvalidRowCount}
          </span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={btn} onClick={closeBulkModal}>닫기</button>
            <button
              style={primaryBtn}
              disabled={bulkSubmitting || bulkNonEmptyCount === 0 || bulkInvalidRowCount > 0}
              onClick={submitBulk}
            >
              {bulkSubmitting ? '등록 중...' : '일괄등록 실행'}
            </button>
          </div>
        </div>
      )}
    >
      <div style={{ display: 'grid', gap: 12 }}>
        {headerExtra}
        <div style={guideBoxStyle}>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>붙여넣기 가이드</div>
          <div style={{ color: 'var(--text-muted)' }}>
            구글 스프레드시트에서 범위를 복사한 뒤 아래 표의 첫 칸을 선택해서 붙여넣으세요.
          </div>
          <div style={{ color: 'var(--text-muted)' }}>
            빨간 칸은 형식 오류이며, 바로 수정할 수 있습니다.
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button style={btn} onClick={() => addBulkRows(10)}>+ 10행 추가</button>
          <button style={btn} onClick={trimEmptyBulkRows}>빈 행 정리</button>
        </div>
        <div style={sheetWrapStyle}>
          <table style={sheetTableStyle}>
            <thead>
              <tr>
                <th style={sheetIndexHeaderStyle}>#</th>
                {columns.map((col) => (
                  <th key={col.key} style={sheetHeaderStyle}>{col.label}{col.required ? ' *' : ''}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {bulkRows.map((row, rowIndex) => (
                <tr key={`bulk-row-${rowIndex}`}>
                  <td style={sheetIndexCellStyle}>{rowIndex + 1}</td>
                  {columns.map((col, colIndex) => {
                    const error = bulkErrors[rowIndex][col.key];
                    const shouldShowError = !isBulkRowEmpty(row) && Boolean(error);
                    return (
                      <td key={`${rowIndex}-${col.key}`} style={sheetCellStyle}>
                        <input
                          list={col.key === 'department' ? 'bulk-departments' : undefined}
                          style={shouldShowError ? errorInputStyle : sheetInputStyle}
                          title={shouldShowError ? error : ''}
                          value={row[col.key]}
                          placeholder={col.placeholder}
                          onChange={(e) => handleBulkCellChange(rowIndex, col.key, e.target.value)}
                          onPaste={(e) => handleBulkCellPaste(e, rowIndex, colIndex)}
                        />
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <datalist id="bulk-departments">
          {departments.map((d) => <option key={d} value={d} />)}
        </datalist>
      </div>
    </Modal>
  );
}
